
<div class="row">
  <div class="col-lg-6 offset-lg-3">
    <mat-card appearance="outlined">
        <mat-card-title>Verify your Identity</mat-card-title>
      <ng-container *ngIf="show_verify_otp">
        <ng-container *ngTemplateOutlet="verify_otp_template"></ng-container>
      </ng-container>
      <ng-container *ngIf="show_another_method">
        <ng-container *ngTemplateOutlet="another_method_template"></ng-container>
      </ng-container>
      <ng-container *ngIf="show_customer_support">
        <ng-container *ngTemplateOutlet="customer_support_template"></ng-container>
      </ng-container>
    </mat-card>
  </div>
</div>

<ng-template #verify_otp_template>
  <mat-card-content>
    <div class="text-center mb-3">Enter the 6-digit code sent to {{masked_user_otp_method}}</div>
    <form [formGroup]="otpForm" class="d-flex gap-2 justify-content-center">
      <div class="col-auto" *ngFor="let key of controls; let i = index">
        <input
          type="text"
          maxlength="1"
          class="form-control text-center otp-input"
          [formControlName]="key.toString()"
          (input)="onInput($event, i)"
          (keydown)="onKeyDown($event, i)"
          (paste)="onPaste($event)"
        />
      </div>
    </form>
    <div class="text-center mb-3 mt-2">
      <button mat-raised-button color="primary" style="width:250px" [disabled]="otpForm.invalid" (click)="verify_otp()">Verify your code</button>
    </div>
    <div class="text-center mb-3">Your verification code expires in {{(otp_ttl_seconds / 60) | number:'1.0-0' }} mins</div>
    <div class="text-center">
      <button class="btn btn-link" *ngIf="canResend" (click)="resend_otp_details()">
        Resend your code
      </button>
      <div *ngIf="!canResend" class="text-muted">
        Didn't receive the code? <span class="resend-timer">You can resend it in :{{ timerValue }}s</span>
      </div>
    </div>
    <div class="text-center">
      <span>Having Trouble?</span>
      <button class="btn btn-link" (click)="try_another_method()">Try another method</button>
    </div>
    <nexus-form-result [model]="form_result"></nexus-form-result>
  </mat-card-content>
</ng-template>

<ng-template #another_method_template>
  <mat-card-content>
    <form [formGroup]="another_method_form">


      <div>
          <label class="form-label">Choose another way to get your code</label>

          <div class="row justify-content-center">
             <mat-radio-group formControlName="mfa_method">
            <div class="text-left">
              <mat-radio-button value="Email">
                <fa-icon [icon]="faEnvelope" class="me-2"></fa-icon>
                Email to {{otp_info_model?.masked_user_email}}
              </mat-radio-button>
            </div>
            <div  *ngIf="otp_info_model?.masked_user_phone" class="text-left">
              <mat-radio-button value="SMS">
                <fa-icon [icon]="faPhone" class="me-2"></fa-icon>
                SMS to {{otp_info_model.masked_user_phone}}
              </mat-radio-button>
            </div>
          </mat-radio-group>
          </div>
      </div>

    </form>
  </mat-card-content>
  <mat-card-actions class="justify-content-center">
          <button mat-raised-button color="primary" style="width:250px" (click)="otp_another_method_cancel()">Cancel</button>
          <button mat-raised-button color="primary" style="width:250px" (click)="resend_otp_another_method()">Send</button>
  </mat-card-actions>
   <nexus-form-result [model]="form_result"></nexus-form-result>
</ng-template>

<ng-template #customer_support_template>
  <mat-card-content>
    <div class="col-form-label text-start mb-3">Choose another way to get your code</div>
    <div class="text-start mb-3">
      Only your primary email is available for receiving codes. To add another method and log-in, please contact <a class="grid-link" target="_blank" href="https://www.simplebills.com/support/">Simple
        Bills Customer Support</a>.
    </div>
  </mat-card-content>
</ng-template>
